import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";
import "./style.scss";

interface AddAdditionalPhoneNumberProps {
  field: {
    type: string;
    name: string;
    id?: string;
    label: string;
    fieldsToAdd: string[];
    class?: string;
  };
  t: { [key: string]: string };
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  className: string;
}

const AddAdditionalPhoneNumber: React.FC<AddAdditionalPhoneNumberProps> = ({
  field,
  t,
  setValue,
  watch,
  className: classNameProp,
}) => {
  const { fieldsToAdd, label, id, class: customClass } = field;
  const [hiddenFieldsLeft, setHiddenFieldsLeft] = useState(fieldsToAdd.length);

  const dataQA = `${field.type}-${field.name}`;
  const buttonID = id || field.name;

  const isRemovedFirstPhoneNumber = watch("removeAdditionalPhoneNumber");
  const isRemovedSecondPhoneNumber = watch("removeAdditionalPhoneNumber2");
  const additionalPhoneNumbersOpened = document.querySelectorAll(
    "div.group--AdditionalPhone, div.group--AdditionalPhone2"
  ).length;

  useEffect(() => {
    // Calculate hidden fields left based on the number of additional phone numbers opened and fields to add
    setHiddenFieldsLeft(fieldsToAdd.length - additionalPhoneNumbersOpened);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalPhoneNumbersOpened, hiddenFieldsLeft]);

  useEffect(() => {
    // Update hidden fields left when a phone number is removed
    setHiddenFieldsLeft((prev) => prev + additionalPhoneNumbersOpened);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRemovedFirstPhoneNumber, isRemovedSecondPhoneNumber]);

  useEffect(() => {
    // Remove first phone numbers button element if 2 additional phone numbers are opened, leaving only the second one
    const phoneNumbersToggle = document.querySelector(".check--removeAdditionalPhoneNumber");
    if (phoneNumbersToggle) {
      phoneNumbersToggle.classList.toggle("u-display-none", additionalPhoneNumbersOpened === 2);
    }
  }, [additionalPhoneNumbersOpened]);

  const addFieldHandler = () => {
    if (hiddenFieldsLeft === fieldsToAdd.length) {
      setValue("removeAdditionalPhoneNumber", false);
    } else if (hiddenFieldsLeft === 1) {
      setValue("removeAdditionalPhoneNumber2", false);
    }

    setHiddenFieldsLeft((prev) => Math.max(prev - 1, 0));
  };

  return (
    <div
      className={classNames("addAdditionalPhoneNumber-wrapper", customClass, {
        "addAdditionalPhoneNumber--hidden": hiddenFieldsLeft === 0,
        [classNameProp as string]: classNameProp,
      })}>
      <div
        onClick={addFieldHandler}
        className="addAdditionalPhoneNumber"
        role="button"
        tabIndex={0}
        aria-label={label}
        data-qa={dataQA}
        id={buttonID}>
        <span>{t[label]}</span>
      </div>
    </div>
  );
};

export default AddAdditionalPhoneNumber;
